// @flow

import { combineReducers } from "redux";
import Layout from "./layout/reducers";
import Auth from "./auth/reducers";
import AppMenu from "./appMenu/reducers";
import App from "./app/reducers";
import Map from "./map/reducers";

export default combineReducers({
  Auth,
  AppMenu,
  App,
  Layout,
  Map,
});
